import { useState } from 'react'
import PartnerForm from "components/PartnerForm";
import Breadcrumbs from '@byma/shared/components/Breadcrumbs'
import Navbar from 'components/Navbar'
import Layout from 'components/Layout'
import useAuth from '@byma/shared/hooks/useAuth'
import fetcher from '@byma/shared/helpers/fetcher'
import useToastContext from "@byma/shared/hooks/useToastContext";
import { useRouter } from 'next/router'

const breadcrumbPaths = [
    { label: 'Equipes', url: `/teams` },
    { label: 'Nova equipe', url: `/teams/new` },
]

export default function NewTeam() {
    const [ isLoading, setIsLoading ] = useState(false)
    const session = useAuth()
    const addToast = useToastContext()
    const router = useRouter()

    const { token } = session

    async function handleCreate(values) {
        setIsLoading(true)
        try {
            await fetcher('/api/partners/create', {
                body: JSON.stringify(values),
                method: 'POST',
            }, token)
            addToast('Equipe salva!')
            router.push('/teams')
        } catch (e) {
            addToast('Erro ao salvar equipe', 'error')
            console.log('error', e)
        }
        setIsLoading(false)
    }

    return (
        <Layout {...{ session }}>
            <div className="p-3">
                <Breadcrumbs paths={breadcrumbPaths} />
            </div>
            <PartnerForm onSubmit={handleCreate} {...{isLoading}} />
        </Layout>
    )
}
